import { z } from 'zod';
export const AudienceFlowWidgetSchema = z.object({
    title: z.string().describe('The title of the audience flow widget'),
    items: z
        .array(z.object({
        id: z.string().describe('The id of the item'),
        title: z.string().describe('The title of the item'),
        description: z.string().describe('The description of the item'),
    }))
        .describe('The list of items in the audience flow widget'),
});
export const AudienceFlowWidgetSchemaKey = 'audience-flow-widget:v1';
export const AudienceFlowWidgetSchemaKind = 'audience';
